export default ['$filter', function ($filter) {

    var ACTION_MSG = {
        saveAndQuoteSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
            }
        }
    };

    function _quoteFailMessage(resp) {
        if (resp && angular.isDefined(resp.extraArgs.error)) {
            var errorMsg = resp.extraArgs.error[0];
            if (angular.isDefined(errorMsg.baseError.error.data) && errorMsg.baseError.error.data.appErrorCode === 602) {
                return {
                    error: {
                        title: 'quoteandbind.common.config.FlowConfig.Underwriting issues have been triggered',
                        message: 'quoteandbind.common.config.FlowConfig.Redirecting to underwriting issues for this quote.',
                        actionLabel: $filter('translate')('gateway.quoteandbind.util.ActionMessageUtil.View Issues')
                    },
                    progress: {
                        message: 'quoteandbind.common.config.FlowConfig.Calculating Quote...'
                    }
                };
            }
        }

        return ACTION_MSG.saveAndQuoteSubmission;
    }

    return {
        quoteFailMessage: function quoteFailMessage(resp) {
            return _quoteFailMessage(resp);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/quoteandbind/common/util/ActionMessageUtil.js
// module id = 1780
// module chunks = 0